import { Flex, FlexProps } from "@chakra-ui/react";

export default function SimpleCard({ children, ...props }: FlexProps) {
  return (
    <Flex
      padding="14px"
      borderRadius="10px"
      border="solid 1px"
      borderColor="border.button.outline"
      bgColor="white"
      boxShadow="button"
      flexDirection="column"
      {...props}
    >
      {children}
    </Flex>
  );
}
